import Vue from "vue";
import Router from "vue-router";
import config from "@/config";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "",
      component: () => import("@/views/default/index.vue"),
      children: [
        {
          path: "",
          component: () => import("@/views/default/_home.vue")
        },
        {
          path: "/login",
          component: () => import("@/views/default/_login.vue")
        },
        {
          path: "/logout",
          component: () => import("@/views/default/_logout.vue")
        },
        {
          path: "/expired",
          component: () => import("@/views/default/_expired.vue")
        },
        {
          path: "/denied",
          component: () => import("@/views/default/_denied.vue")
        }
      ]
    },
    {
      path: "/system",
      component: () => import("@/views/system/index.vue"),
      children: [
        {
          path: "/system",
          redirect: "/system/default",
          meta: { requiredLoggedIn: true }
        },
        {
          path: "/system/default",
          component: () => import("@/views/system/_default.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          path: "/system/settings",
          component: () => import("@/views/system/_settings.vue"),
          meta: { requiredLoggedIn: true }
        }
      ],
      meta: { requiredLoggedIn: true }
    },
    {
      path: "/number",
      component: () => import("@/views/number/index.vue"),
      children: [
        {
          path: "/number/defaultNumber",
          component: () => import("@/views/number/_redNumberDefault.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          path: "/number/matchNumber",
          component: () => import("@/views/number/_redNumberMatch.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          path: "/number/betListExport",
          component: () => import("@/views/number/_betListExport.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          path: "/number/compMatchNumber",
          component: () => import("@/views/number/_redNumberMatch_Company.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          path: "/number/compBetListExport",
          component: () => import("@/views/number/_betListExport_Company.vue"),
          meta: { requiredLoggedIn: true }
        }
      ],
      meta: { requiredLoggedIn: true }
    }
  ]
});

export default router;
